import { Directive } from '@angular/core';

@Directive({
  selector: '[comp-dialog-header-title]',
})
export class DialogHeaderTitleDirective {}

@Directive({
  selector: '[comp-dialog-header-subtitle]',
})
export class DialogHeaderSubtitleDirective {}

@Directive({
  selector: '[comp-dialog-header-action-items]',
})
export class DialogHeaderActionItemsDirective {}

@Directive({
  selector: '[comp-dialog-content]',
})
export class DialogContentDirective {}

@Directive({
  selector: '[comp-dialog-footer]',
})
export class DialogFooterDirective {}
